import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Box, Heading, Text } from '@pancakeswap/uikit'
import { FileText, Lock } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'
import { AutoRow } from 'components/Layout/Row'

const AuditsModal = ({ close, modalStyle, frameStyle, iconStyle, iconContainerStyle }) => {
  const { t } = useTranslation()

  return (
    <Modal
      defaultPosition={{ x: 8, y: 8 }}
      icon={<Lock variant="16x16_4" />}
      title="Audits"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`Audits`)}
        </Heading>

        <Text fontSize="18px">
          {t(
            `We value the trust and confidence of our investors above all else. We have already achieved several audit milestones, and you can view the results here. These audits are conducted by third parties to ensure that our contract code is completely secure and free of any fraud or vulnerabilities.`,
          )}
        </Text>

        <Text fontSize="18px" mt="16px" mb="16px">
          {t(`Read through the audits reports and you will be able to invest in our token with utmost confidence.`)}
        </Text>

        <Text fontWeight="bold" fontSize="18px" mb="24px">
          {t(`Windoge95 V2 Audits are still pending, but in the mean time check out the audits for V1 below:`)}
        </Text>
        <AutoRow justify="center" align="center">
          <a href="/pdfs/watchtower_audit.pdf" target="_blank">
            <Box
              style={{
                width: '154px',
                textAlign: 'center',
                marginLeft: '16px',
                marginTop: '16px',
                marginBottom: '16px',
                cursor: 'pointer',
              }}
            >
              <FileText style={iconStyle} />
              <Text color="black" fontSize="20px" textAlign="center">
                {t('Crypto Watchtower')}
              </Text>
            </Box>
          </a>
          <a href="/pdfs/mythx_audit.pdf" target="_blank">
            <Box style={iconContainerStyle}>
              <FileText style={iconStyle} />
              <Text color="black" fontSize="20px" textAlign="center">
                {t('MythX')}
              </Text>
            </Box>
          </a>
          <a href="/pdfs/tech_rate_audit.pdf" target="_blank">
            <Box style={iconContainerStyle}>
              <FileText style={iconStyle} />
              <Text color="black" fontSize="20px" textAlign="center">
                {t('Tech Rate')}
              </Text>
            </Box>
          </a>
        </AutoRow>
      </Frame>
    </Modal>
  )
}

export default AuditsModal
